import gql from 'graphql-tag'
import { BMDialogFloorFragment } from '@api/fragments'
import { BMDialogFloor } from '@api/types'
import client from '@stores/apollo'

export default function details(id: string): Promise<BMDialogFloor> {
  return client.gql
    .query({ query, variables: { id } })
    .then(({ data: { node: building } }: { data: { node: BMDialogFloor } }) => building)
}

const query = gql`
  query FloorDetails($id: ID!) {
    node(id: $id) {
      ...BMDialogFloorFragment
    }
  }
  ${BMDialogFloorFragment}
`
